import { bezierPoint } from 'silkpath'
import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class RoundedRectangle extends Symbol2d {

  handles = [{
    defaults: [.15, 0],
    constraints: (dimensions, handles) => {
      let max = Math.min(dimensions.width / 2, dimensions.height / 2) / dimensions.width
      return [
        [0, max], null
      ]
    },
    cursor: 'ew-resize'
  }]

  getRadius (dimensions, handles) {
    return Math.min(dimensions.width * handles[0][0], dimensions.height / 2, dimensions.width / 2)
  }

  path (dimensions, handles) {
    const _path = path()
    // It will be a percentage of the width, which is the axis we're using for dragging
    // Make sure it's less than half the width/height
    const radius = this.getRadius(dimensions, handles)

    _path.moveTo(radius, 0)
    _path.lineTo(dimensions.width - radius, 0) // upper right
    _path.arcTo(dimensions.width, 0, dimensions.width, radius, radius)
    _path.lineTo(dimensions.width, dimensions.height - radius) // lower right
    _path.arcTo(dimensions.width, dimensions.height, dimensions.width - radius, dimensions.height, radius)
    _path.lineTo(radius, dimensions.height)
    _path.arcTo(0, dimensions.height, 0, dimensions.height - radius, radius)
    _path.lineTo(0, radius)
    _path.arcTo(0, 0, radius, 0, radius)
    _path.lineTo(radius, 0) // Close it
    _path.closePath()
    return _path.toString()
  }

  textContainer(dimensions, handles) {
    // Calculate the effective radius based on the handles
    const radius = this.getRadius(dimensions, handles)

    // Find the midpoint of the curve
    const P0 = [dimensions.width - radius, 0] // Start point
    const P1 = [dimensions.width, 0] // Control point
    const P2 = [dimensions.width, radius] // End point
    const midpoint = bezierPoint(0.5, P0, P1, P1, P2) // Use P1 as the control point for both segments since it's a quadratic curve

    const offset = dimensions.width - midpoint[0]
    const width = dimensions.width - offset * 4
    const height = dimensions.height - midpoint[1] * 4


    return {
      center: dimensions.center,
      width,
      height,
    }
  }

  getMiter () {
    // The rounded rect uses `A` commands, which are not supported by the miter limit calculation
    // We can rely on the browser default since this shape doesn't have sharp corners
    // See https://github.com/SpiderStrategies/Scoreboard/issues/57240
    return null
  }

}
